import { filter, each, unionWith, map, find } from 'lodash-es'
import addSearch from '@/modules/utils/api/addSearch'
import { api } from '@/api'
import to from '@/modules/await-to-js'
import defaultSettings from '@/configuration/settings.default'

const state = {
  settings: defaultSettings
}

export const getters = {
  settings: state => state.settings.list,

  // Filter dashboard settings from settings and format it to an object
  dashboardSettings: state => {
    const dashboardSettingsArray = filter(state.settings.list, setting => setting.category === 'dashboard')
    const dashboardSettings = {}
    each(dashboardSettingsArray, setting => {
      dashboardSettings[setting.key] = setting.value
    })
    return dashboardSettings
  },

  alarmsRefresh: (state) => {
    return find(state.settings.list, (s) => { return s.key === 'alarmsRefresh' }).value
  },

  healthRefresh: (state) => {
    return find(state.settings.list, (s) => { return s.key === 'healthRefresh' }).value
  },

  remoteShellActivation: (state) => {
    return find(state.settings.list, (s) => { return s.key === 'remoteShellActivation' }).value
  },

  tilesServerUrl: (state) => {
    return find(state.settings.list, (s) => { return s.key === 'tilesServerUrl' }).value
  },

  tilesServerAttribution: (state) => {
    return find(state.settings.list, (s) => { return s.key === 'tilesServerAttribution' }).value
  }
}

export const mutations = {
  setSettings (state, settings) {
    state.settings = {
      list: unionWith(
        map(settings.list, setting => {
          setting.value = JSON.parse(setting.value)
          return setting
        }),
        defaultSettings.list,
        (setting, defaultSetting) => {
          return setting.category === defaultSetting.category && setting.key === defaultSetting.key
        }
      )
    }
  }
}

export const actions = {
  async getSettings (context) {
    const options = { search: JSON.stringify(addSearch([], 'eq', context.rootGetters.authenticatedUser.customer.id, 'customer.id')) }

    let error, response
    [error, response] = await to(api.getCustomersSettings(context.rootGetters.application), options)
    if (error || !response) return Promise.reject(error)

    context.commit('setSettings', response.data)
    return Promise.resolve(response)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
